import { routes } from "@/includes/BaseTemplateConfig/routes";
import { sidebar } from "@/includes/BaseTemplateConfig/sidebar";

import store from "@/store/store";
import { AdminTemplateOptions, } from "piramis-base-components/src/plugins/AdminTemplate/includes/types/Config";
import { ProductNames } from "piramis-base-components/src/plugins/AdminTemplate/components/OurProducts/types";
import { User } from "@/includes/types/User";
import { errorNotification } from "@/includes/services/NotificationService";
import { navbar } from "@/includes/BaseTemplateConfig/navbar";

export const BaseTemplateConfig: AdminTemplateOptions['config'] =  {
  meta: {
    projectName: 'TgScout.app',
    apiUrl: 'api.tgscout.app/cabinet',
    projectDomain: 'https://tgscout.app',
    sidebarLogo: require('../../assets/images/tgscout-logo/logo_title.png'),
    loginPageLogo: require('../../assets/images/tgscout-logo/login_page_logo.png'),
    tgResolvers: {
      supportBotDomain: 'TgScoutSupportRu',
      promotionBotDomain: 'ChatKeeperPromotionBot',
      mainBotDomain: 'tgscoutbot',
    },
    login: {
      botAuthLink: 'https://t.me/tgscoutbot?start=cabinetlink',
      loginWidget: {
        botLogin: 'tgscoutbot',
        tgWidgetAuthLink: 's/tg/d/login?bot_id=1047364105',
      }
    },
    languageCodes: [ 'ru', 'en' ],
    isSaveButtonVisible: false,
    paymentEntity: {
      target_type: (ctx) => {
        return {
          target_id: {
            user_key: store.state.userState.allUsers!.find(u => u.key.split('.')[0] === ctx?.route.params.id)!.key,
          },
          target_type: 'user'
        }
      }
    },
  },
  footer: {
    version: store.getters.PACKAGE_VERSION,
    ourProducts: {
      exclude: [ ProductNames.TGSCOUTBOT ]
    }
  },
  loyaltySystem: {
    partnerBlock: {
      partnerLink: (localeCode) => 'https://t.me/ChatKeeperPromotion/?start=loyalty_parnters'
    },
    companiesBlock: {
      termsOwnerLink: (localeCode) => 'https://t.me/ChatKeeperPromotion/?start=loyalty_parnters'
    }
  },
  companyRegistration: {
    powerOfAttorney: (localeCode): string => 'https://tgscout.app/wp-content/uploads/2022/06/power_of_attorney_ur.doc',
    howToRegisterUr: (localeCode): string => 'https://tgscout.app/wp-content/uploads/2022/06/how_to_register_ur-3.docx',
  },
  search: {
    entities: (ctx): any => {
      if (store.state.userState.allUsers !== null && Array.isArray(store.state.userState.allUsers) && store.state.userState.allUsers.length) {
        return store.state.userState.allUsers.map((e: any) => {
          e.id = e.key.split('.')[0]
          return e
        })
      } else {
        return []
      }
    },
    path: (ctx, router, selectedId): void => {
      if (selectedId) {
        router.push({
          name: 'User',
          params: {
            id: selectedId.toString(),
          }
        })
      }
    }
  },
  rightScreenButton: {
    link: (localeCode): string => {
      if (localeCode === 'ru') return 'https://t.me/PressCodeSupportRu'
      else return 'https://t.me/PressCodeSupport'
    },
  },
  serviceData: {
    type: 'ServiceData',
    tariffs: {
      starter: {
        type: 'TariffInfo',
        img: require('../../assets/images/payments/tariffs/starter.png'),
        color: 'rgb(181,192,212)'
      },
      advanced: {
        type: 'TariffInfo',
        img: require('../../assets/images/payments/tariffs/advanced.png'),
        color: 'rgb(241,154,64)'
      },
      ultimate: {
        type: 'TariffInfo',
        img: require('../../assets/images/payments/tariffs/ultimate.png'),
        color: 'rgb(177,69,250)',
      },

    },
  },
  navbar,
  routes,
  sidebar,
  globalGuards: {
    beforeEach: async (to, from, next): Promise<void> => {
      if (!to.params.id) {
        await store.commit('CLEAR_TRIGGERS_FROM_STORE')
        await store.commit('CLEAR_ACTIVE_TRIGGERS_IDS')
        await store.commit('CLEAR_USER_FROM_STORE')
      }

      if (to.params.id) {
        if (!store.state.userState.allUsers) {
          await store.dispatch('REQUEST_USERS')
        }

        const user: User | null = store.getters.getCurrentUser(to.params.id)

        if (user) {
          if (!store.state.userState.currentUserConfig?.user) {
            await store.dispatch('REQUEST_USER_CONFIG', user.key)
          }

          if (store.state.userState.currentUserConfig?.user.key.split('.')[0] !== to.params.id) {
            store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', true)
            await store.dispatch('REQUEST_USER_CONFIG', user.key)
            store.commit('AdminTemplate/TOGGLE_GLOBAL_LOADER', false)
          }
        } else {
          next({
            name: "Users"
          })
          errorNotification("User not found")
        }

      }

      next()
    },
  },
  onSaveButtonClick: (ctx, wasClicked): void => {
    if (ctx?.route?.params?.id) {
      store.dispatch('SAVE_CONFIG_WARN', store.state.userState.currentUserConfig?.user.key)
    }
  },
}